(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1816],{

/***/ 62227:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; },
/* harmony export */   "default": function() { return /* binding */ Home; }
/* harmony export */ });
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

// import TextOrVideo from "components/TextOrVideo";
// import HomePage from "components/homePage";
 // import { useDispatch, useSelector } from "react-redux";
// import { useEffect } from "react";
// import { allFeaturedData, allpostData } from "redux/actions/postAction";
// export const config = { amp: true }
// const HomePage = dynamic(() => import("../../components/homePage"), {
//   ssr: true,
// });


var TextOrVideo = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(2962), __webpack_require__.e(7758), __webpack_require__.e(719), __webpack_require__.e(3977), __webpack_require__.e(2971), __webpack_require__.e(1818), __webpack_require__.e(782), __webpack_require__.e(4044), __webpack_require__.e(5613), __webpack_require__.e(8087), __webpack_require__.e(9778), __webpack_require__.e(8483), __webpack_require__.e(9836)]).then(__webpack_require__.bind(__webpack_require__, 69373));
}, {
  ssr: true,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(69373)];
    }
  }
}); // export const config = { amp: "hybrid" };

var __N_SSP = true;
function Home(props) {
  // const dispatch = useDispatch();
  // const { allPosts, featuredPosts  } = useSelector(({PostReducer})=>PostReducer)
  // useEffect(() => {
  //   const contentType = "video";
  //   dispatch(allpostData({ contentType }));
  //   dispatch(allFeaturedData({ contentType }));
  // }, [dispatch]);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(TextOrVideo, _objectSpread({}, props));
}

/***/ }),

/***/ 61645:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/video",
      function () {
        return __webpack_require__(62227);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [532,2888,179], function() { return __webpack_exec__(61645); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);